/* CSS Document */

var jLoadTimer = setInterval(function(){
	if(typeof jQuery != "undefined"){

		clearInterval(jLoadTimer);

		jQuery(function($){
			gradiate($);
			scroll_to_add($);
			floatButtonFunc($);
		});
	}
}, 100);

function gradiate($){
	var bg = $(".contentBody > .bg > div, #floatButton");
			
	var wdw = $(window);
	wdw.scroll(function(){
		var docH = $(document).height() - wdw.height();
		var per = Math.floor(wdw.scrollTop() / docH * 100);
		bg.css({backgroundPosition: "0 "+per+"%"});
	});

	wdw.scroll();
}

function scroll_to_add($){
	var addOnPosition = 0.75;//開始位置設定window高さの75%のところにきたらclass:onが追加
	var wdw = $(window);
	var anims = $(".anime");

	anims.each(function(){
		var target = $(this);
		if(target.data("children")){
			var children = target.data("children").split(",");
			var arr = [];
			for(var i=0;i<children.length;i++){
				$(children[i], target).each(function(){
					arr.push($(this));
					});//each
				}//for
			target.data("children", arr);
			}//if
		});//each


	function addOn(sct){
		anims.each(function(){
			var target = $(this);

			if(target.offset().top < sct){
				if(target.hasClass("on")) return;

				//on追加
				if(target.data("children")){
					var delay = (target.data("delay")) ? target.data("delay") : 0;
					var arr = target.data("children");
					for(var s in arr){
						setTimeout(setClassOn(arr[s]), delay*s);
						}
					//親にもクラス追加
					target.addClass("on");
					}else
				if(target.data("delay")){
					setTimeout(setClassOn(target), target.data("delay"));
					}else{
						target.addClass("on");
						}
				}else{
					if(!target.hasClass("on")) return;

					//on削除
					/*if(target.data("children")){
						var arr = target.data("children");
						for(var s in arr){
							arr[s].removeClass("on");
							}
						}*/

					//data-children有無にかかわらずクラスanimeにon削除
					//target.removeClass("on");
					}//if
			});//each
		}//addOn

	function setClassOn(target){
		return function(){
			target.addClass("on");
			};
		}

	wdw.scroll(function(){
		var sct = wdw.scrollTop()+wdw.height()*addOnPosition;
		addOn(sct);
		});
	wdw.scroll();
}

function floatButtonFunc($){
	var wdw = $(window);
	var mindset = $(".contentBody .circle");
	var floatButton = $("#floatButton");
	var signArea = $("#sign");
	
	wdw.scroll(function(){
		var sct = wdw.scrollTop();
		var wh = wdw.height()*0.5;
		var mtTop = mindset.offset().top;
		if(sct+wh > mtTop && sct+wh < signArea.offset().top){
			if(!floatButton.hasClass("ready")){
				floatButton.addClass("ready");
				setTimeout(function(){floatButton.addClass("on");}, 10);
			}
		}else{
			if(floatButton.hasClass("ready")){
				floatButton.removeClass("on");
				setTimeout(function(){if(!floatButton.hasClass("on")) floatButton.removeClass("ready");}, 300);
			}
		}
	});
	wdw.scroll();
	
}